import styled from 'styled-components';
import Header from './Header';
import { mediaQueries } from '../shared/config'

const Container = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: bottom;
    justify-content: bottom;
    ${mediaQueries.tablet} {
        min-height: 50vh;
  }
    @media (max-width: 700px){
        justify-content: center;
        min-height: 40vh;
    }
`




export default function Landing(props){

const Illo = styled.div`
width: 100vw;
height: auto;
min-height: 115vh;

background-image: url(${props.landing_image});
background-size: cover;
object-fit: cover;
${mediaQueries.fullscreen} {
    min-height: 90vh;
}
${mediaQueries.tablet} {
    min-height: 70vh;
    height: auto;
}
${mediaQueries.mobile} {
    min-height: 45vh;
}
p {
    font-family: 'Inter', sans-serif;
    color: #E5E5E5;
    text-align: right;
    font-style: italic;
    align-items: bottom;
    justify-content: bottom;
    position: absolute;
    bottom: 0;
    right: 0;

    ${mediaQueries.mobile} {
        margin-left: 50%;
        font-size: 12px;

  }
}
`
    return(
        <>
            <Container>
                <Illo >
                <p>
                    {props.landing_credits}
                </p>
                </Illo>
                
            </Container>
            
        </>
        

    );
}